import { useState } from "react";
import IconVisibility from "../../../../../components/icons/icon-visibility/icon-visibility";
import { Input } from "../../../../../components/inputs/input/input";
import { IValidationGroup } from "../../../../../hooks/validation-group/validation-group-hook";

interface IPasswordInputProps {
    value?: string;
    onChange: (value: string) => void;
    validationGroup: IValidationGroup;
}

export const PasswordInput: React.FC<IPasswordInputProps> = ({ value, onChange, validationGroup }) => {
    const confirmSwitchVisibility = () => {
        if (type === 'password') {
            setConfirmNewType('text');
            setConfirmIconColor('var(--color-primary-2)');
        } else {
            setConfirmNewType('password');
            setConfirmIconColor('var(--primary-grey)');
        }
    }

    const [type, setConfirmNewType] = useState('password');
    const [iconColor, setConfirmIconColor] = useState('var(--primary-grey)');

    return <Input
        value={value}
        type={type}
        onChange={onChange}
        minlength={8}
        maxlength={16}
        button={{
            iconComp: () => <IconVisibility color={iconColor} />,
            onClick: confirmSwitchVisibility
        }}
        required
        validationGroup={validationGroup}
    />
}
